import React from 'react'

function ViewService({ service, closeModal }) {
    if (!service) return null;
    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
      }
    const url = 'uploads/'
    const { date, time } = formatDateTime(service?.createdAt);
    return (
        <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="manufacturerModal">Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body px-5">
                        <div className="d-box mt-3 pt-1">
                            {/* <h3 className="service-heading" style={{ marginBottom: '10px' }}>About</h3> */}
                            <ul className="d-flex list-unstyled justify-content-between">
                                <li><span>Category Name: </span>{service?.category?.title}</li>
                                <li><span>Sub Category Name: </span>{service?.subCategory?.title}</li>
                                <li><span>Title: </span>{service?.title}</li>
                                <li><span>Description: </span> {service?.description}</li>
                                <li><span>Status: </span> {service?.status}</li>
                                <li><span>Date: </span> {formatDateTime(service?.createdAt)}</li>
                            </ul>
                            {/* <h3 className="service-heading" style={{ marginBottom: '10px' }}>Service</h3>
                            <ul className="d-flex list-unstyled flex-wrap">
                                {service?.included?.map((item, index) => (
                                    <li key={index}>
                                        <span>Step {index + 1}: </span>{item}
                                    </li>
                                ))}
                            </ul> */}


                            <h3 className="service-heading" style={{ marginBottom: '10px' }}>Gallery</h3>
                            <ul className="d-flex list-unstyled flex-wrap">
                                {service?.images?.map((image, index) => (
                                    <li key={index} className="m-2">
                                        <img src={`${process.env.REACT_APP_URL}${image}`} alt="Service" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewService